import { Swiper, Pagination, Navigation } from 'swiper';
import 'swiper/scss';

Swiper.use(Pagination);
Swiper.use(Navigation);

class CarouselTimeline extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.$items = this.querySelector('.js-carousel-timeline__items');
    this.$prevBtn = this.querySelector('.js-carousel-timeline__prev');
    this.$nextBtn = this.querySelector('.js-carousel-timeline__next');
    this.$pagination = this.querySelector('.js-carousel-timeline__pagination');
    if (this.$items) this.setupCarousel();
  }

  setupCarousel() {
    this.carousel = new Swiper(this.$items, {
      slidesPerView: 1,
      navigation: {
        nextEl: this.$nextBtn,
        prevEl: this.$prevBtn,
      },
      pagination: {
        el: this.$pagination,
        type: 'progressbar',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1260: {
          slidesPerView: 3,
        },
      },
    });
  }
}

export default function init() {
  customElements.define('carousel-timeline', CarouselTimeline);
}
